import { createTheme } from '@mui/material';

const theme = createTheme({
  typography: {
    fontSize: 12, // Tamaño base de la fuente
  },
  // Aquí puedes agregar más configuraciones para tu tema
});

export default theme;
